import "./FloatingActionButtons.scss";

import * as React from "react";
import { useHistory } from "react-router-dom";
import { Spinner } from "../Spinner/Spinner";
import { Button, ButtonProps } from "../Buttons/Button";

export interface IFloatingActionButtons {
  isLoading: boolean;
  actionButtons: ButtonProps[];
}

export const FloatingActionButtons = (props: IFloatingActionButtons) => {
  const history = useHistory();

  return (
    <div className="floating-actions-container">
      <div className="floating-actions-wrapper">
        <Spinner loading={props.isLoading} />
        <Button
          id="actie-annuleren"
          key={"actie-annuleren"}
          buttonText="Annuleren"
          layout="secondary"
          disabled={props.isLoading}
          clickHandler={() => history.goBack()}
        />
        {props.actionButtons.map((element) => {
          return (
            <Button
              id={element.id}
              key={element.id}
              buttonText={element.buttonText}
              layout={element.layout}
              disabled={element.disabled}
              clickHandler={element.clickHandler}
            />
          );
        })}
      </div>
    </div>
  );
};
